export default function debounce(fn, delay) {
    let timer = null;
    let resolvePromise = null;

    return function (...args) {
        clearTimeout(timer);

        return new Promise((resolve) => {
            resolvePromise = resolve;

            timer = setTimeout(async () => {
                const result = await fn.apply(this, args);
                resolvePromise(result);
            }, delay);
        });
    };
}
